import React from 'react';

function About() {
    return (
        <h1 className="title">About project...</h1>
    );
}

export default About;
